<!--

Size:
default
large
small

Classes:
primary
secondary
icon
no-label
ghost

State:
:hover / hover
:active / active
:disabled / disabled
:invalid / negative

-->

<div class="input-widget" [ngClass]="[style, state, size, type === 'file' ? 'withPhoto' : '']">
  <span (click)="showPass = !showPass" [ngClass]="[showPass ? 'show-password' : 'hide-password']"></span>

  <label class="input-container sp-input">
    <input
      #textInput
      [disabled]="disabled"
      [autofocus]="autofocus"
      [required]="required"
      [multiple]="multiple"
      (blur)="onBlur()"
      [class.data-hj-whitelist]="true"
      [class.focus]="touched"
      [name]="name"
      [ngClass]="[state]"
      [type]="showPass ? 'text' : type"
      [attr.step]="type === 'number' ? step : null"
      (change)="onChangeEvent($event)"
      (keyup)="onChangeEvent($event)"
      (input)="onChangeEvent($event)"
      [value]="type === 'file' ? null : value"
      [placeholder]="placeholder"
      (focus)="onFocus($event)"
    />

    <span class="input-container-label" *ngIf="type !== 'file'">{{ label }}</span>
    <p class="input-container-label-countryCode" *ngIf="specialPlaceholder">{{ specialPlaceholder }}</p>
    <div class="input-container-label-controls" *ngIf="type === 'number'">
      <span class="plus" (click)="numberAction('add', step)" [class.disabled]="value === max" [class.disabled]="disabled">+</span>
      <span class="minus" (click)="numberAction('subtract', step)" [class.disabled]="value === min" [class.disabled]="disabled">-</span>
    </div>
    <div *ngIf="icon">
      <sp-icon
        *ngIf="!spinnerLoading"
        class="icon icon-left"
        [inherit]="true"
        [status]="valid ? 'success' : 'negative'"
        [name]="!valid ? icon : 'file-images-check'"
        type="solid"
      ></sp-icon>
      <!-- TODO: loading-spinner needs to be styled to replace the icon and fit properly -->
      <loading-spinner *ngIf="spinnerLoading"></loading-spinner>
    </div>
  </label>
  <img *ngIf="photoUrl" [src]="photoUrl" class="input-file-image" />
  <span class="input-widget-warning" *ngIf="warning">{{ warning }}</span>
  <!-- <div *ngIf="errors">
    <div *ngFor="let error of errors">{{ error }}</div>
  </div> -->
</div>
